webpackJsonp([34],{

/***/ 1535:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SystemNotifications_vue__ = __webpack_require__(1893);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c41f8da_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SystemNotifications_vue__ = __webpack_require__(2325);
function injectStyle (ssrContext) {
  __webpack_require__(2321)
  __webpack_require__(2323)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c41f8da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SystemNotifications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c41f8da_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SystemNotifications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1555:
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ 1557:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1559), __esModule: true };

/***/ }),

/***/ 1558:
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 1559:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1560);
module.exports = __webpack_require__(105).Object.assign;


/***/ }),

/***/ 1560:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(183);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1561) });


/***/ }),

/***/ 1561:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(154);
var getKeys = __webpack_require__(955);
var gOPS = __webpack_require__(1558);
var pIE = __webpack_require__(1555);
var toObject = __webpack_require__(954);
var IObject = __webpack_require__(959);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(442)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ 1572:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1557);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ 1893:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_api__ = __webpack_require__(952);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// Nazwy z NotificationType (API zwraca nazwe, nie numer) na klucze tlumaczen.
var TYPE_KEYS = {
    NewTask: 'NotificationTypeNewTask',
    ClosedTask: 'NotificationTypeClosedTask',
    ResponseToTask: 'NotificationTypeResponseToTask',
    NewAnimalDidNotEat: 'NotificationTypeAnimalDidNotEat',
    NewAlarm: 'NotificationTypeNewAlarm'

    // Nazwy z NotificationSendStatusEnum na klucze tlumaczen.
};var STATUS_KEYS = {
    Pending: 'NotificationStatusPending',
    Sent: 'NotificationStatusSent',
    Failed: 'NotificationStatusFailed',
    FailedPermanently: 'NotificationStatusFailedPermanently',
    SkippedStale: 'NotificationStatusSkippedStale',
    SkippedNoRecipient: 'NotificationStatusSkippedNoRecipient',
    SkippedNoSystem: 'NotificationStatusSkippedNoSystem',
    SkippedAlreadyRead: 'NotificationStatusSkippedAlreadyRead',
    SkippedSeenInApp: 'NotificationStatusSkippedSeenInApp',
    LegacyProcessed: 'NotificationStatusLegacyProcessed'
};

var FAILED_STATUSES = ['Failed', 'FailedPermanently'];

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        systemName: {
            required: false,
            type: String
        },
        systemId: {
            required: false,
            type: String
        }
    },
    computed: {
        failedCount: function failedCount() {
            return this.data.filter(function (el) {
                return FAILED_STATUSES.includes(el.status);
            }).length;
        }
    },
    provide: {
        grid: [__WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["l" /* Sort */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["i" /* Page */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["g" /* Filter */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["m" /* Toolbar */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["k" /* Search */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["b" /* CommandColumn */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["j" /* PdfExport */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["f" /* ExcelExport */]]
    },
    data: function data() {
        return {
            data: [],
            runMessage: '',
            runError: '',
            pageSettings: { pageSize: 100, pageSizes: [10, 25, 50, 100] },
            toolbar: [
            // Wysylka rusza sama kilkanascie sekund po zapisaniu powiadomienia; przycisk
            // jest do testow i do ponowienia po awarii bramki. Endpoint wymaga roli Admin.
            this.$store.getters.isAdmin ? { text: this.$t('SendNow'), id: 'send-now', prefixIcon: 'e-play', align: 'Left' } : null, { text: this.$t('ClearFilter'), id: 'clear-filters', prefixIcon: 'e-cancel', align: 'Right' }, { text: this.$t('Excelexport'), prefixIcon: 'e-excelexport', align: 'Right', id: 'excel-export' }, { text: this.$t('Pdfexport'), prefixIcon: 'e-pdfexport', align: 'Right', id: 'pdf-export' }, { text: this.$t('Csvexport'), prefixIcon: 'e-csvexport', align: 'Right', id: 'csv-export' }, 'Search'].filter(Boolean),
            wrapSettings: { wrapMode: "Content" },
            selectionOptions: { type: "Multiple" },
            filterOptions: {
                type: "CheckBox"
            },
            customAttributes: { class: "customcss" },
            errorAttributes: { class: ["customcss", "notification-error-cell"] },
            dateTimeFormatOptions: { format: 'yyyy-MM-dd HH:mm:ss', type: 'dateTime' }
        };
    },

    methods: {
        getData: function getData() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var notifications;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.$store.dispatch('set_loading', true);

                                _context.prev = 1;
                                _context.next = 4;
                                return Object(__WEBPACK_IMPORTED_MODULE_5__api_api__["_73" /* getSystemNotifications */])(_this.systemId);

                            case 4:
                                notifications = _context.sent;


                                _this.data = notifications.map(function (el) {
                                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, el, {
                                        // CreateDate zapisywany jest w UTC, wiec przeliczamy na strefe przegladarki -
                                        // inaczej godzina wysylki rozjezdza sie o offset.
                                        createDate: __WEBPACK_IMPORTED_MODULE_4_moment___default.a.utc(el.createDate).toDate(),
                                        recipientName: el.recipientName || el.recipientEmail || '-',
                                        typeLabel: TYPE_KEYS[el.type] ? _this.$t(TYPE_KEYS[el.type]) : el.type,
                                        statusLabel: STATUS_KEYS[el.status] ? _this.$t(STATUS_KEYS[el.status]) : el.status,
                                        sentAt: el.sentAt ? __WEBPACK_IMPORTED_MODULE_4_moment___default.a.utc(el.sentAt).toDate() : null,
                                        // Kod i tresc w jednej kolumnie - kod jest tym, czego sie szuka, tresc jest kontekstem.
                                        errorText: el.errorCode ? "" + el.errorCode + (el.errorMessage ? ' — ' + el.errorMessage : '') : ''
                                    });
                                });

                            case 6:
                                _context.prev = 6;

                                _this.$store.dispatch('set_loading', false);
                                return _context.finish(6);

                            case 9:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[1,, 6, 9]]);
            }))();
        },
        sendNow: function sendNow() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var result;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this2.runMessage = '';
                                _this2.runError = '';

                                _context2.prev = 2;
                                _context2.next = 5;
                                return Object(__WEBPACK_IMPORTED_MODULE_5__api_api__["_113" /* sendNotificationsNow */])();

                            case 5:
                                result = _context2.sent;


                                _this2.runMessage = result.message || _this2.$t('NotificationsSendResult', {
                                    pending: result.pending,
                                    sent: result.sent,
                                    failed: result.failed,
                                    rejected: result.rejected,
                                    skipped: result.skippedStale + result.skippedBroken + result.skippedRead
                                });

                                _context2.next = 9;
                                return _this2.getData();

                            case 9:
                                _context2.next = 14;
                                break;

                            case 11:
                                _context2.prev = 11;
                                _context2.t0 = _context2["catch"](2);

                                _this2.runError = _this2.$t('SendNowFailed');

                            case 14:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2, [[2, 11]]);
            }))();
        },

        dataBound: function dataBound() {
            // Bez listy autoFit rozciagnalby kolumne bledu do pelnej tresci komunikatu z FCM.
            this.$refs.grid.autoFitColumns(['createDate', 'statusLabel', 'typeLabel', 'recipientName', 'recipientEmail']);
        },
        toolbarClick: function toolbarClick(args) {
            switch (args.item.id) {
                case "send-now":
                    this.sendNow();
                    break;
                case "pdf-export":
                    this.$refs.grid.pdfExport();
                    break;
                case "csv-export":
                    this.$refs.grid.csvExport();
                    break;
                case "excel-export":
                    this.$refs.grid.excelExport();
                    break;
                case 'clear-filters':
                    this.$refs.grid.clearFiltering();
                    break;
            }
        }
    },
    mounted: function mounted() {
        this.getData();
    }
});

/***/ }),

/***/ 2321:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2322);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("8817c962", content, true, {});

/***/ }),

/***/ 2322:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".notifications-bar[data-v-3c41f8da]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:6px 16px;min-height:32px;margin-bottom:10px;font-size:13px}.hint[data-v-3c41f8da]{color:var(--text-muted)}.run-message[data-v-3c41f8da]{color:var(--brand-text);font-weight:600}.run-error[data-v-3c41f8da]{color:var(--danger);font-weight:600}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/System/SystemNotifications.vue"],"names":[],"mappings":"AAiLA,oCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,mBAAoB,AAChB,eAAgB,AACpB,aAAc,AACd,gBAAiB,AACjB,mBAAoB,AACpB,cAAgB,CACnB,AACD,uBACI,uBAAyB,CAC5B,AACD,8BACI,wBAAyB,AACzB,eAAiB,CACpB,AACD,4BACI,oBAAqB,AACrB,eAAiB,CACpB","file":"SystemNotifications.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* Wysokosc razem z marginesem miesci sie w 68 px, ktore .grid-filters odejmuje od tabeli. */\n.notifications-bar[data-v-3c41f8da] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    gap: 6px 16px;\n    min-height: 32px;\n    margin-bottom: 10px;\n    font-size: 13px;\n}\n.hint[data-v-3c41f8da] {\n    color: var(--text-muted);\n}\n.run-message[data-v-3c41f8da] {\n    color: var(--brand-text);\n    font-weight: 600;\n}\n.run-error[data-v-3c41f8da] {\n    color: var(--danger);\n    font-weight: 600;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2323:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2324);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("34a3c62b", content, true, {});

/***/ }),

/***/ 2324:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".e-grid td.notification-error-cell{white-space:nowrap!important;overflow:hidden;text-overflow:ellipsis}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/System/SystemNotifications.vue"],"names":[],"mappings":"AA8MA,mCACI,6BAA+B,AAC/B,gBAAiB,AACjB,sBAAwB,CAC3B","file":"SystemNotifications.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* allowTextWrap na calym gridzie wylacza clipMode - bez tego 512-znakowy blad z FCM\n   rozciagalby wiersz na pol ekranu. Pelna tresc jest w tooltipie. Styl nie jest scoped,\n   bo komorki renderuje Syncfusion, bez atrybutu data-v tego komponentu. */\n.e-grid td.notification-error-cell {\n    white-space: nowrap !important;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-container"},[_c('div',{staticClass:"notifications-bar"},[_c('span',{staticClass:"hint"},[_vm._v(_vm._s(_vm.$t('NotificationsStatusHint')))]),_vm._v(" "),(_vm.failedCount)?_c('span',{staticClass:"run-error"},[_vm._v(_vm._s(_vm.$t('NotificationsFailedCount', { count: _vm.failedCount })))]):_vm._e(),_vm._v(" "),(_vm.runMessage)?_c('span',{staticClass:"run-message"},[_vm._v(_vm._s(_vm.runMessage))]):_vm._e(),_vm._v(" "),(_vm.runError)?_c('span',{staticClass:"run-error"},[_vm._v(_vm._s(_vm.runError))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"max-grid grid-filters"},[_c('ejs-grid',{ref:"grid",attrs:{"height":"100%","width":"100%","toolbar":_vm.toolbar,"toolbarClick":_vm.toolbarClick,"selectionSettings":_vm.selectionOptions,"allowTextWrap":true,"textWrapSettings":_vm.wrapSettings,"dataBound":_vm.dataBound,"dataSource":_vm.data,"allowPaging":true,"pageSettings":_vm.pageSettings,"allowFiltering":true,"filterSettings":_vm.filterOptions,"allowSorting":true,"allowMultiSorting":true,"allowPdfExport":true,"allowCsvExport":true,"allowExcelExport":true,"showBusyIndicator":true}},[_c('e-columns',[_c('e-column',{attrs:{"field":"createDate","headerText":_vm.$t('CreateDate'),"textAlign":"Left","customAttributes":_vm.customAttributes,"type":"dateTime","format":_vm.dateTimeFormatOptions}}),_vm._v(" "),_c('e-column',{attrs:{"field":"statusLabel","headerText":_vm.$t('Status'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"sentAt","headerText":_vm.$t('SentAt'),"width":"150px","textAlign":"Left","customAttributes":_vm.customAttributes,"type":"dateTime","format":_vm.dateTimeFormatOptions}}),_vm._v(" "),_c('e-column',{attrs:{"field":"typeLabel","headerText":_vm.$t('Type'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"recipientName","headerText":_vm.$t('Recipient'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"recipientEmail","headerText":_vm.$t('Email'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"body","headerText":_vm.$t('Description'),"width":"400px","textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"errorText","headerText":_vm.$t('NotificationError'),"width":"240px","clipMode":"EllipsisWithTooltip","textAlign":"Left","customAttributes":_vm.errorAttributes}})],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/34.981340c5c3eb57535c3d.js